"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var mirrorScrollLeft_1 = __importDefault(require("./mirrorScrollLeft"));
// Return normalized scroll value which simulates scrollRight for RTL
// Scroll by 20px from the left side in LTR, returns 20
// Scroll by 20px from the right side in RTL, returns 20
var getElementScroll = function (el) {
    return (0, mirrorScrollLeft_1.default)(el, el.scrollLeft);
};
exports.default = getElementScroll;
